module.exports = __webpack_public_path__ + "static/media/facebook_icon.a08d8fde.svg";